export const isValidString = (s) =>
  !!s && typeof s === "string" && s.trim() !== "";
